import { createSlice } from '@reduxjs/toolkit'

export type commonStateType = {
  //addEentlistener 중첩 방지 상태관리 배열
  RecaptchaRefresh: boolean
  loginStatus: boolean
  //기본값은 false, 리캡챠 토근 발급 완료 시 true, 새로고침시 리캡챠 재발급 확인용
  RecaptchaTokenUpdateFlag: boolean
  //reset, login errtxt
  errText: string | null
  loadingStatus: boolean
}

const initialState: commonStateType = {
  RecaptchaRefresh: false,
  loginStatus: false,
  RecaptchaTokenUpdateFlag: false,
  errText: null,
  loadingStatus: false,
}

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setRecaptchaRefresh(state, action) {
      state.RecaptchaRefresh = action.payload
    },

    setLoginStatus(state, action) {
      state.loginStatus = action.payload
    },
    setRecaptchaTokenUpdateFlag(state, action) {
      state.RecaptchaTokenUpdateFlag = action.payload
    },
    setErrText(state, action) {
      state.errText = action.payload
    },
    ResetErrText(state) {
      state.errText = null
    },
    setLoadingStatus(state, action) {
      state.loadingStatus = action.payload
    },
  },
})

export const {
  ResetErrText,
  setErrText,
  setLoginStatus,
  setRecaptchaRefresh,
  setRecaptchaTokenUpdateFlag,
  setLoadingStatus,
} = commonSlice.actions

export default commonSlice.reducer
